import { workloadStatusesEnum } from "helpers/enums";
import React from "react";

const Status = ({ status }) => {
    switch (status) {
        case workloadStatusesEnum.NotStarted:
        case workloadStatusesEnum.Running:
            return (
                <div className="bg-task__loader ml-2">
                    <i className="loading loading--small" />
                </div>
            );
        case workloadStatusesEnum.Completed:
            return <i className="icon-uEA85-check-circle text-success ml-2" />;
        case workloadStatusesEnum.Faulted:
            return <i className="icon-uEAB8-circle-xmark text-danger ml-2" />;
    }
    return null;
};

export default Status;
